/*
 * Project: Dynamedics Portal Web
 * Created Date: Friday July 8th 2022
 * Author: Naveen Mendis
 * -----
 * Last Modified: Saturday July 9th 2022 1:40:25 am
 * Modified By: Naveen Mendis at <naveenm@mitrai.com>
 * -----
 * Copyright (c) 2022 Mitra Sparks
 * -----
 * HISTORY:
 */

// material
import { Box } from '@material-ui/core';
import { CLIENT_LOGO_FILE } from '../../utils/constants';
import { mediaBaseUrl } from '../../config';
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------

export default function ClientLogo({ height, ...other }) {
  const auth = useAuth();
  if (auth && auth.user && auth.user.clientName) {
    const clientName = auth.user.clientName;
    return (
      <Box
        component="img"
        alt=""
        src={`${mediaBaseUrl}/${clientName}/${CLIENT_LOGO_FILE}`}
        height={height}
        maxHeight={32}
        paddingRight={1}
        {...other}
      />
    );
  } else {
    return <Box></Box>;
  }
}
